/**
 * icon-section.js
 */

import React from 'react';
import {
  useMediaQuery,
  Box,
  Typography,
} from '@mui/material';
import Icon from 'components/icon';
import HelpDialog from 'components/help-dialog';
import { useTranslation } from 'react-i18next';


const getHelpList = (i18n, translation, section) => {
  if (!translation || !section) {
    return [];
  }

  const resource = i18n.getResourceBundle(i18n.language, translation);
  const sectionObj = resource?.[section] ?? {resource};
  return Object
    .entries(sectionObj)
    .filter(([key, val]) => key !== 'sectionName' && val.helpTitle && val.helpInfo);
}


const MobileTitle = (props) => {
  const {
    title,
    onClickHelp
  } = props;

  return (
    <Box className='flex-hc' onClick={onClickHelp} sx={{ color: onClickHelp ? 'sys.primary' : 'inherit', py: 0.25, mb: 1 }}>
      <Typography sx={{ fontWeight: 500, fontSize: 'sizes.2' }}>{title}</Typography>
      {onClickHelp && <Icon type='help' sx={{ ml: 1, fontSize: 'sizes.4', color: 'sys.onSurfaceVariant' }} />}
    </Box>
  )
}


export const EditorIconSection = (props) => {
  return (
    <IconSection iconMarginTop={10} {...props} />
  )
}


export default function IconSection(props) {
  const {
    iconName,
    iconSize,
    iconMarginTop,
    helpProps,
    children,
    ...rest
  } = props;
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('md'), { noSsr: true });
  const { t, i18n } = useTranslation(helpProps?.translation ?? '');
  const helpFieldList = React.useMemo(() => getHelpList(i18n, helpProps?.translation, helpProps?.section), [i18n, helpProps]);
  const [openHelp, setOpenHelp] = React.useState(false);
  const title = helpProps?.section ? t(`${helpProps?.section}.sectionName`) : '';
  const label = title.toUpperCase() + (helpProps?.suffix || '');


  const onHelpOpen = (e) => {
    e.preventDefault();
    setOpenHelp(true);
  };


  return (
    <>
      <Box sx={{ display: 'flex', mb: 3 }} className='pt-icon-section' {...rest}>
        <Icon 
          type={iconName} 
          fontSize={iconSize || (isMobile ? 'medium' : 'large')} 
          sx={{ 
            mr: {
              xs: 1.5,
              md: 2,
            },
            marginTop: {
              xs: 0,
              md: `${iconMarginTop ?? 0}px`,
            },
            color: {
              xs: 'sys.primary',
              md: 'sys.onSurfaceVariant'
            }
          }}
        />
        <Box sx={{ 
          flex: 1, 
          display: 'flex', 
          flexDirection: 'column', 
          justifyContent: 'center', 
        }}>
          <Box>
            {isMobile && label &&
            <MobileTitle title={label} onClickHelp={helpFieldList.length > 0 ? onHelpOpen : null} />}

            <Box className='pt-icon-section-content'>
              {children}
            </Box>
          </Box>
        </Box>
      </Box>
      
      {/* help dialog */}
      <HelpDialog
        open={openHelp}
        onClose={() => setOpenHelp(false)}
        iconName={iconName}
        title={title}
        helpFieldList={helpFieldList}
      />
    </>
  );
}